import { useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import Swal from 'sweetalert2';
import { clearDB } from '../db';
import { useChatStore } from '../stores/ChatStore';
import { checkSessionByPhone } from '../api/ChatHelper';

const useHandleCheckSessionChat = () => {
    const { selectedChatPhone, message, groupMessage, setGroupMessage, setMessage } = useChatStore();
    const intl = useIntl()

    // simpan retry counter
    const retryCounterRef = useRef<{ [key: string]: number }>({});

    const handleSessionDisconnected = async () => {
        await clearDB();
        Swal.fire({
            title: 'Session Disconnected',
            icon: 'warning',
            allowOutsideClick: false,
        }).then(async () => {
            await clearDB();
            window.location.reload();
        });
    };

    const handleCheckSession = async (type: string, funct?: () => void) => {
        const timeout = type === 'sendChat' || type === 'sendChatGroup' ? 2000 : 10000;

        try {
            const results = await Promise.all(
                selectedChatPhone.map(async (data) => {
                    const response = await checkSessionByPhone(data.phone);
                    return response.data.status ? 0 : 1;
                })
            );

            const countError = results.reduce((sum: number, val: number) => sum + val, 0);

            if (countError > 0) {
                handleSessionDisconnected();
            } else if (funct) {
                // inisialisasi counter kalau belum ada
                if (!(type in retryCounterRef.current)) {
                    retryCounterRef.current[type] = 0;
                }

                if (type === 'sendChat' || type === 'sendChatGroup') {
                    // cek sudah lebih dari 10x atau belum
                    if (retryCounterRef.current[type] >= 10) {
                        if (message) setMessage(message);
                        if (groupMessage) setGroupMessage(groupMessage);

                        retryCounterRef.current[type] = 0; // reset counter
                        Swal.fire({
                            icon: "error",
                            title: intl.formatMessage({ id: "FORM.LABEL.NETWORK_ERROR" }),
                            text: intl.formatMessage({ id: "FORM.LABEL.DESC_NETWORK_ERROR" }),
                            toast: true,
                            position: "bottom-end",
                            showConfirmButton: false,
                            timer: 10000,
                            customClass: {
                                title: "swal2-title-custom",
                                popup: "swal2-popup-custom",
                                htmlContainer: "swal2-text-custom"
                            }
                        });
                        return;
                    }
                    retryCounterRef.current[type] += 1;
                }

                setTimeout(() => {
                    funct();
                }, timeout);
            }
        } catch {
            // kalau gagal checkSession, coba lagi checkSession, 
            // tapi tidak hitung sebagai retry funct
            handleCheckSession(type, funct);
        }
    };

    return { handleCheckSession };
};

export default useHandleCheckSessionChat;